import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';

import './fonts/HelveticaNowDisplay/HelveticaNowDisplay-Regular.otf';
import './fonts/HelveticaNowDisplay/HelveticaNowDisplay-Medium.otf';
import './fonts/HelveticaNowDisplay/HelveticaNowDisplay-Bold.otf';
import './fonts/HelveticaNowDisplay/HelveticaNowDisplay-Black.otf';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<React.StrictMode><App /></React.StrictMode>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
